const RELOAD_KEY = 'sf_chunk_reload_at';
// a second failure within this window means the reload did not help, so stop
const RELOAD_GUARD_MS = 60 * 1000;

// JS chunks fail with name 'ChunkLoadError'; CSS chunks (mini-css-extract) only set code/message,
// and chunk ids may contain '.' because splitChunks uses '.' as the name delimiter
export const isChunkLoadError = (error: any) =>
  error?.name === 'ChunkLoadError' ||
  error?.code === 'CSS_CHUNK_LOAD_FAILED' ||
  /Loading (CSS )?chunk \S+ failed/i.test(error?.message || '');

// After a deploy, a tab that was opened earlier may request route chunks that no longer exist.
// Reload once to pick up the new index.html; returns false if the error is unrelated or we
// already reloaded recently.
export const reloadOnChunkLoadError = (error: any): boolean => {
  if (!isChunkLoadError(error)) return false;
  try {
    const last = Number(sessionStorage.getItem(RELOAD_KEY) || 0);
    if (Date.now() - last < RELOAD_GUARD_MS) return false;
    sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
  } catch (e) {
    // sessionStorage unavailable: reloading without a guard could loop forever
    return false;
  }
  window.location.reload();
  return true;
};
